import React from 'react';
import { theme } from 'antd';
import * as Styled from './CustomTitle.styled';

interface ITitleProps {
  title: string;
  level?: 5 | 1 | 2 | 3 | 4;
}

const { useToken } = theme;

const CustomTitle: React.FC<ITitleProps> = ({ title, level }) => {
  const { token } = useToken();

  return (
    <Styled.StyledTitle level={level} token={token}>
      {title}
    </Styled.StyledTitle>
  );
};

export default CustomTitle;
